











































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DeleteLogs from "./deletelogs.vue";
import SearchTree from "@/lib/Common/searchtree";

class PageLogsRequest extends PageRequest {
  keyword: string;
  areaId: number;
  operationType: number;
  user: string;
  startTime: string;
  endTime: string;
}

@Component({
  components: { DeleteLogs },
})
export default class LogsList extends AbpBase {
  //复制
  async del() {
    this.deleModalShow = true;
  }
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  deleModalShow: boolean = false;
  splitnum: number = 0.15;

  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.logs.list;
  }
  get loading() {
    return this.$store.state.logs.loading;
  }
  isActiveChange(val: number) {
    this.$store.commit("logs/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("logs/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("logs/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("logs/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    if (this.pagerequest.startTime == null) {
      this.pagerequest.startTime = Moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    if (this.pagerequest.endTime == null) {
      this.pagerequest.endTime = Moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    await this.$store.dispatch({
      type: "logs/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.logs.pageSize;
  }
  get totalCount() {
    return this.$store.state.logs.totalCount;
  }
  get currentPage() {
    return this.$store.state.logs.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      sortable: true,
      title: this.L("RecordName"),
      key: "recordName",
      width: 150,
      fixed: "left",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.recordName },
            },
            params.row.recordName
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("OperationType"),
      key: "operationType",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.operationType;
        let str = this.L("Unknown");
        switch (id) {
          case 1:
            str = this.L("Add");
            break;
          case 2:
            str = this.L("Edit");
            break;
          case 3:
            str = this.L("Delete");
            break;
          case 4:
            str = this.L("Export");
            break;
          case 5:
            str = this.L("Pay");
            break;
          case 6:
            str = this.L("Reduction");
            break;
          case 7:
            str = this.L("Recharge");
            break;
          case 8:
            str = this.L("Refund");
            break;
          case 9:
            str = this.L("Quota");
            break;
          default:
            str = this.L("Unknown");
            break;
        }
        return h("span", str);
      },
    },
    {
      sortable: true,
      title: this.L("CreationTime"),
      key: "createTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.createTime == null
            ? ""
            : new Date(params.row.createTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      sortable: true,
      title: this.L("ActionUser"),
      key: "user",
      width: 130,
    },
    {
      sortable: true,
      title: this.L("OldInfo"),
      key: "oldInfo",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.oldInfo },
            },
            params.row.oldInfo
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("NewInfo"),
      key: "newInfo",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.newInfo },
            },
            params.row.newInfo
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("OperationState"),
      key: "operationState",
      width: 130,
    },
  ];
  async created() {
    var dt = new Date();
    this.pagerequest.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  // 时间触发
  changeTime(time) {
    this.pagerequest.startTime = Moment(time[0], "YYYY-MM-DD HH:mm:ss")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment(time[1])
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
    //console.log(this.pagerequest)
  }
  data() {
    return {
      paramslist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      options2: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
